import moment from 'moment-timezone';

import {
  openError,
  openSuccess,
  openWarning,
} from '../../../../../packages/neb-dialog/neb-banner-state';
import { store } from '../../../../../packages/neb-redux/neb-redux-store';
import { PT_INS_INFO_CONFIG } from '../../../../utils/ar-hub/column-definitions';
import { downloadCsv } from '../../../../utils/export-to-csv';

const getConfig = (config, withPtInsInfo) => {
  if (!withPtInsInfo) {
    return config;
  }

  const ptInsInfoColumns = PT_INS_INFO_CONFIG.map(({ key }) => key);
  const configTail = config.filter(
    ({ key }) => !ptInsInfoColumns.includes(key),
  );
  return [...PT_INS_INFO_CONFIG, ...configTail];
};

export default ({ model, config, withPtInsInfo }) => {
  if (!model || model.length === 0) {
    console.warn('No data to export.');
    return;
  }

  const filename = `AR_Hub_Data_${moment().format('YYYY.MM.DD')}.csv`;

  try {
    const success = downloadCsv(
      getConfig(config, withPtInsInfo),
      model,
      filename,
    );

    if (success) {
      store.dispatch(
        openSuccess(
          'Export successful. Please check your downloads for the file.',
        ),
      );
    } else {
      store.dispatch(openWarning('No data to export.'));
    }
  } catch (error) {
    store.dispatch(openError('Error exporting data.', error));
  }
};
